import cx from "classnames";
import { CTA } from "common/styleguide/CTA";
import { base } from "lib/styleguide/base.scss";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./S2DMobileView.scss";

export const S2DMobileView = ({ route, routeId, platform }) => {
  const appLink =
    platform === "iphone"
      ? "itms-apps://appstore.com/ridewithgpsbikecomputer"
      : "http://play.google.com/store/apps/details?id=com.ridewithgps.mobile";

  const routeLink = `rwgps://app/routes/${routeId}`;
  return (
    <div className={cx(styles.S2DMobileView, base)}>
      <div>
        <img height="150" width="150" className={styles.routePreview} src={`/routes/light/${routeId}.png`} />
      </div>
      <h2>
        <T
          id="s2d.mobileView1"
          defaultMessage='Download the free Ride with GPS app to view "{routeName}".'
          values={{
            routeName: route && route.name,
          }}
        />
      </h2>
      <CTA href={appLink}>
        <T
          id="s2d.mobileView2"
          defaultMessage="Download on the {store} App Store"
          values={{ store: platform === "iphone" ? "App Store" : "Play Store" }}
        />
      </CTA>
      <a href={routeLink} className={styles.hasApp}>
        <T id="s2d.mobileView4" defaultMessage="Already have the mobile app?" />
      </a>
    </div>
  );
};
